import { render } from "./MDBTooltip.vue?vue&type=template&id=4197e7b7"
import script from "./MDBTooltip.vue?vue&type=script&lang=js"
export * from "./MDBTooltip.vue?vue&type=script&lang=js"

import exportComponent from "/home/mdb/repos/MDB/VUE/Release/build-tool/dev/mdb-vue-dev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__